import { Fragment, useEffect, useRef, useState } from "react";
import VideoCard from "../../components/common/VideoCard";
import useSelectVideo from "../../hooks/useSelectVideo";
import { useLocation } from "react-router-dom";

export function OtherUserPosts({ otherUser_posts, nextPage }) {
    const menuRef = useRef(null);
    const [postId, setPostId] = useState(null);
    const selectVideo = useSelectVideo();
    const location = useLocation();

    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setPostId(null);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSelectVideo = async (id) => {
        selectVideo(id, otherUser_posts, location.pathname, 'otherUser', nextPage);
    };

    return (
        <Fragment>
            {otherUser_posts?.length > 0 ? (
                <div className={`grid grid-cols-3 gap-1 no-scrollbar px-2 py-1 z-10`}>
                    {otherUser_posts?.map((item) => (
                        <VideoCard
                            id={item.id}
                            belowDecs={true}
                            threeDots={false}
                            views={item.views}
                            video={item.video_url}
                            body={item.post_description}
                            view_count={item.view_count}
                            likes_count={item.likes_count}
                            authorId={item.created_by?.id}
                            selectVideo={handleSelectVideo}
                            avatar_url={item.created_by.avatar_url}
                            thumbnail={item.thumbnail_url}
                        />
                    ))}
                </div>
            ) : (
                <div className="flex justify-center items-center">
                    <p className="text-[12px] mt-5 text-gray-400 dark:text-gray-500">
                        No Posts Yet
                    </p>
                </div>
            )}
        </Fragment>
    );
}
